import React from "react";

function Implants() {
  return <div>Implants</div>;
}

export default Implants;
